
<div class="modal-dialog" style="max-width: 1000px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="w-100 px-4">
        <div class="row justify-content-between">
          <h5 class="modal-title">{{ site }}</h5>
          <button class="close" type="button" (click)="clear()">&times;</button>
        </div>
        <div class="row justify-content-between mt-4">
          <h5 class="modal-title">{{ createSelected ? 'Create ' + titleModifier : titleModifier}}</h5>
          <div *ngIf="allowCreate">
            <button class="btn btn-outline-primary btn-sm px-4" *ngIf="!createSelected" type="button" [disabled]="!allowCreate" (click)="createAddressEnable()">Create Address</button>
            <button class="btn btn-outline-primary btn-sm px-4" *ngIf="createSelected" type="button" [disabled]="!allowCreate" (click)="searchAddressEnable()">Select Address</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <success></success>
      <div *ngIf="loading">
        <md-spinner-block></md-spinner-block>
      </div>
      <div *ngIf="!loading">
        <div class="m-2">
          <div class="container-fluid spreadsheet-container" *ngIf="!createSelected">
            <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
            <div *ngIf="!displayedItsmAddresses || displayedItsmAddresses.length === 0">
              <p class="text-center empty-table-message">There are no addresses to display.</p>
            </div>
            <div style="overflow-x: scroll" *ngIf="displayedItsmAddresses.length &gt; 0">
              <table class="table table-bordered border-top-0 mt-4" style="width: 1150px">
                <thead>
                  <tr class="tr-header-edit-asset">
                    <th class="pl-5" style="width: 25%">Site & Building</th>
                    <th style="width: 20%">Address Names</th>
                    <th style="width: 20%">Address Lines</th>
                    <th style="width: 20%">City, Region & Postal Code</th>
                    <th style="width: 15%">Country</th>
                  </tr>
                </thead>
                <tbody style="font-size: 0.8rem">
                  <ng-container *ngIf="displayedItsmAddresses">
                    <ng-container *ngFor="let address of displayedItsmAddresses;">
                      <tr [ngStyle]="{'font-weight': address.id === selectedTmcAddressId ? 'bold' : 'normal'}">
                        <td>
                          <div class="w-100 display-box">
                            <input class="align-middle mr-4" type="radio" name="selectedAddressRadio" ngbTooltip="Select Address" (change)="setAddress(address.id)" [checked]="address.id === selectedTmcAddressId">
                            <div><span>Site: {{address.itsmSiteName}}</span><br><span>Bldg: {{address.itsmBuilding}}</span></div>
                          </div>
                        </td>
                        <td><span>Name 1: {{address.name1}}</span><br><span>Name 2: {{address.name2}}</span></td>
                        <td><span>Name 1: {{address.line1}}</span><br><span>Name 2: {{address.line2}}</span></td>
                        <td><span>{{address.city}}</span><br><span>{{address.region | region}}</span><br><span>{{address.postalCode}}</span></td>
                        <th>{{address.country | country}}</th>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="container" *ngIf="createSelected" style="font-size: 0.9rem">
            <form [formGroup]="addressForm" (ngSubmit)="false">
              <div class="row">
                <div class="form-group col-sm-6" *ngIf="requireBpId">
                  <label class="required" for="modifyBpId">Business Partner ID</label>
                  <input class="form-control" id="modifyBpId" type="text" formControlName="businessPartnerId" name="businessPartnerId">
                </div>
                <div class="form-group col-sm-6">
                  <label class="required">Building Types</label>
                  <select class="form-control" formControlName="buildingTypes" name="buildingTypes" required>
                    <option *ngFor="let buildingType of buildingTypes" [ngValue]="buildingType.value">{{ buildingType.humanReadable }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyBuilding">Building</label>
                  <input class="form-control" id="modifyBuilding" type="text" formControlName="itsmBuilding" name="itsmBuilding">
                </div>
                <div class="form-group col-sm-6" *ngIf="!hideDeliveryType">
                  <label>Delivery Type</label>
                  <select class="form-control" formControlName="deliveryType" name="deliveryType">
                    <option *ngFor="let dt of deliveryTypes" [ngValue]="dt.key">{{ dt.humanReadable }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyAddressName1">Address Name 1</label>
                  <input class="form-control" id="modifyAddressName1" type="text" formControlName="name1" name="name1">
                </div>
                <div class="form-group col-sm-6">
                  <label for="modifyAddressName2">Address Name 2</label>
                  <input class="form-control" id="modifyAddressName2" type="text" formControlName="name2" name="name2">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyAddressLine1">Address Line 1</label>
                  <input class="form-control" id="modifyAddressLine1" type="text" formControlName="line1" name="line1">
                </div>
                <div class="form-group col-sm-6">
                  <label for="modifyAddressLine2">Address Line 2</label>
                  <input class="form-control" id="modifyAddressLine2" type="text" formControlName="line2" name="line2">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required" [for]="'modifyAddressCountry'">Country</label>
                  <select-country [inputId]="'modifyAddressCountry'" formControlName="country" [inputName]="'country'" [countryId]="countryId" [textOnly]="true" [disabled]="true"></select-country>
                </div>
                <div class="form-group col-sm-6">
                  <label class="required" [for]="'modifyAddressRegion'" [class.required]="isRegionRequired">Region</label>
                  <select-region [inputId]="'modifyAddressRegion'" formControlName="region" [inputName]="'region'" [countryId]="countryId"></select-region>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyAddressCity">City</label>
                  <input class="form-control" id="modifyAddressCity" type="text" formControlName="city" name="city">
                </div>
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyAddressPostalCode">Postal Code</label>
                  <input class="form-control" id="modifyAddressPostalCode" type="text" formControlName="postalCode" name="postalCode">
                </div>
              </div>
              <div class="row">
                <div class="col-12 my-3">
                  <h5>Shipping Labels</h5>
                </div>
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyCustomShippingLabel1">Shipping Label 1</label>
                  <input class="form-control" id="modifyCustomShippingLabel1" type="text" formControlName="customShippingLabel1" name="customShippingLabel1" (focus)="onFocus(shippingLabelParameters.customShippingLabel1)">
                </div>
                <div class="form-group col-sm-6">
                  <label class="required" for="modifyCustomShippingLabel2">Shipping Label 2</label>
                  <input class="form-control" id="modifyCustomShippingLabel2" type="text" formControlName="customShippingLabel2" name="customShippingLabel2" (focus)="onFocus(shippingLabelParameters.customShippingLabel2)">
                </div>
              </div>
            </form>
            <div class="m-2">
              <div class="row mb-2">
                <div class="col text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide DOR Data" *ngIf="toggleCustomLabelHelperVisible" (click)="toggleCustomLabelHelperVisible = false">Shipping Label Helper<span class="icon oi oi-chevron-top ml-3"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show DOR Data" *ngIf="!toggleCustomLabelHelperVisible" (click)="toggleCustomLabelHelperVisible = true">Shipping Label Helper<span class="icon oi oi-chevron-bottom ml-3"></span></a></div>
              </div>
              <ng-container *ngIf="toggleCustomLabelHelperVisible">
                <div class="row">
                  <div class="form-group col-lg-12"><span>Shipping Label 1 and 2 must be both set.</span><br><span>All placeholders must be exact including case and include no extra space.</span>Example:  Attn. &#123;FirstName} &#123;LastName} #&#123;MailStop}</div>
                  <div class="form-group col-lg-12"><span>The following placeholders can be used in your shipping labels:</span></div>
                </div>
                <div class="mx-3">
                  <div class="row px-3 py-2 border-bottom" *ngFor="let placeholder of placeholders"><span style="font-weight:bold;width:20%;">{{ placeholder.name }} &nbsp;&nbsp;</span><a style="width:10%" href="javascript:void(0);" (click)="addPlaceholder(placeholder.name)">Add</a><span style="width:70%">&nbsp;{{ placeholder.description }}</span></div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <button class="btn btn-outline-secondary mr-3 btn-sm px-4" type="button" title="Cancel" (click)="clear()">Cancel</button>
        <button class="btn btn-outline-primary btn-sm px-4" *ngIf="!createSelected" type="submit" (click)="submit()">Select</button>
        <button class="btn btn-outline-primary btn-sm px-4" *ngIf="createSelected" type="submit" (click)="createItsmAddress()">Create Address</button>
      </div>
    </div>
  </div>
</div>